import { getProperty } from 'dot-prop';
import { UserState } from '../reducers/UserReducer';

type FetchSelectDataParams = {
    action: (userData: UserState["userProfileData"], search: string, page: number) => Promise<any>;
    search: string;
    page: number;
    setter: React.Dispatch<React.SetStateAction<{ options: any[], hasNextPage: boolean } | null>>
    userData: UserState["userProfileData"];
    filterOrFind?: (option: any) => boolean;
    resultPath?: string;
}

export const fetchSelectData = async ({ action, search, page, setter, userData, filterOrFind, resultPath = 'data.results' }: FetchSelectDataParams) => {
    const result = await action(userData, search, page);

    const hasNextPage = result.data?.next ? true : false;

    let options = getProperty(result, resultPath, []) as string[] | undefined;

    if (!options) {
        return;
    }

    if (filterOrFind) {
        options = options?.filter(filterOrFind); // Apply filter or find function to the options
    }

    if (page === 1 || !page) {
        setter({ options, hasNextPage });
    }
    else {
        setter(prevData => ({ options: [...prevData?.options || [], ...(options || [])], hasNextPage }));
    }
};
